import { render, staticRenderFns } from "./AlmaFormHeader.vue?vue&type=template&id=53ebc7d0&scoped=true&"
import script from "./AlmaFormHeader.vue?vue&type=script&lang=js&"
export * from "./AlmaFormHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ebc7d0",
  null
  
)

export default component.exports